module.exports = __webpack_public_path__ + "static/ClickedPermanentlyDisabledYellow-441600c628f221b580c6ab6a2b72a898.png";